module.exports = "pegasus_template/assets/themelp1/ebook/105.png";